enum MapLayerItemTypes {
	Camera = 1,
	Audio = 2,
	Relay = 3,
	Alarm = 4,
	Output = 5,
	Geofence = 6,
	Guard = 100,
	Waypoint = 101,
	Note = 102,
	FinalSureViewMapLayerItemType = 1000
}

export default MapLayerItemTypes;